import src from "IMAGE";
export default { src, width: 372, height: 60, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAIAAABsYngUAAAAIUlEQVR42mO4pKx8WUvrsqbmFV3dyzo6/RISygoKKioqAG2oB0w1l0QcAAAAAElFTkSuQmCC", blurWidth: 8, blurHeight: 1 }
